import { jsxs as r, jsx as d } from "react/jsx-runtime";
const o = ({ currency: e }) => /* @__PURE__ */ r("div", { className: "text-xxs relative rounded-md px-2 py-1 font-bold uppercase", children: [
  /* @__PURE__ */ d("div", { className: "bg-THEME-primary absolute left-0 top-0 h-full w-full rounded-md opacity-30" }),
  e
] });
export {
  o as CurrencyBadge
};
